import React, { FC, useState } from "react";
import { Button, InputField } from "../forms";
import { ModalPropsDTO } from "../../typings/generic";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../utils/regex";
import { ListPicker } from "../generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";
import { onInviteUsers } from "../../services/users/Usermanagement";
import { toast } from "react-toastify";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";

const AdduserModal = (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const companypicker = usePickerhook();
  const deptrolepick = usePickerhook();
  const userrolepick = usePickerhook();
  const employeePickpermmision = usePickerhook();
  const { config } = useStateGetter();
  const { setLoading } = useStateSetter();
  const { UserOrgs } = useOrganizationHook();
  const watchedFields = watch(["firstname", "lastname", "email", "phone"]);
  const userTypes = [
    { name: "Administrator", code: "Admin" },
    { name: "Read only", code: "User" },
    { name: "Regular user", code: "User" },
  ];
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      companypicker.pickedRole &&
      employeePickpermmision.pickedRole &&
      userrolepick.pickedRole
  );

  const onSubmit = async (data: any) => {
    console.log(data);
    setLoading(true);
    const postData = {
      firstName: data.firstname,
      lastName: data.lastname,
      phoneNumber: data.phone,
      email: data.email,
      password: data.password,
      orgRole: "Admin",
      userRole:
        userrolepick.pickedRole.code == ""
          ? "Admin"
          : userrolepick.pickedRole.code,
      deptRole:
        deptrolepick.pickedRole.code == ""
          ? "Admin"
          : deptrolepick.pickedRole.code,
      organizationID: companypicker.pickedRole.code,
    };
    try {
      console.log(postData);
      var resposnse = await onInviteUsers(postData, config);
      setLoading(false);

      if (resposnse.success) {
        toast.success(resposnse.message);
        props.show(false);
      }
    } catch (e: any) {
      setLoading(false);
      console.log(e);
      toast.error(e);
    }
  };
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col rounded-[8px] bg-white w-[40vw] p-4 max-h-[90vh] overflow-x-hidden overflow-y-scroll ">
          <p className="font-semibold self-start text-sm ">Add User</p>
          <div className=" grid grid-cols-2 gap-4  	 ">
            <InputField
              name="firstname"
              title="Firstname"
              placeholder={"Firstname"}
              control={control}
              rules={{
                required: "First name is required",
                pattern: {
                  value: textReg,
                  message: "Invalid first name",
                },
              }}
            />
            <InputField
              name="lastname"
              title="Lastname"
              placeholder={"lastname"}
              control={control}
              rules={{
                required: "last name is required",
                pattern: {
                  value: textReg,
                  message: "Invalid last name",
                },
              }}
            />

            <InputField
              name="email"
              title="Email Address"
              placeholder={"Enter Email Address"}
              control={control}
              rules={{
                required: "Email Address is required",
                pattern: {
                  value: emailReg,
                  message: "Invalid Email Address",
                },
              }}
            />

            <InputField
              name="phone"
              title="Phone number"
              placeholder={"Enter phone number"}
              control={control}
              rules={{
                required: "Phone number is required",
                pattern: {
                  value: numReg,
                  message: "Invalid phone number",
                },
              }}
              type={"number"}
            />
          </div>

          <div className="w-full ">
            <ListPicker
              fullwidth
              hook={companypicker}
              title="Company"
              list={UserOrgs.map((i) => {
                return { name: i.orgName, code: i.id };
              })}
            />
          </div>
          <p className="font-semibold self-start mt-2 ">Permissions</p>
          <div className=" w-full  grid grid-cols-3 justify-start items-start">
            <ListPicker
              fullwidth
              hook={userrolepick}
              title="Users"
              defaultvalue={userTypes[0]}
              list={userTypes}
            />
          </div>

          <p className="font-semibold self-start mt-2 text-sm ">
            Human Resource modules
          </p>
          <div>
            <div className="   w-full gap-2  grid grid-cols-3">
              <ListPicker
                fullwidth
                hook={employeePickpermmision}
                title="Employee"
                defaultvalue={userTypes[0]}
                list={userTypes}
              />
              <ListPicker
                fullwidth
                hook={userrolepick}
                title="Payroll"
                defaultvalue={userTypes[0]}
                list={userTypes}
              />
              <ListPicker
                fullwidth
                hook={userrolepick}
                title="Appraisal"
                defaultvalue={userTypes[0]}
                list={userTypes}
              />
            </div>
          </div>
          <div className={` w-full  ${"grid  grid-cols-2 gap-3"}`}></div>
          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Add user"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AdduserModal;
